<template>
    <div class="app-container">

        <el-row class="navigation">
            <el-col align="left">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item :to="{ path: '' }">当前位置:</el-breadcrumb-item>
                    <el-breadcrumb-item :to="{ path: '/main/index' }">首页</el-breadcrumb-item>
                    <el-breadcrumb-item :to="{ path: '' }">NQI服务</el-breadcrumb-item>
                    <el-breadcrumb-item>标准服务</el-breadcrumb-item>
                </el-breadcrumb>
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="6">
                <el-row class="left-img">
                    <img src="@/assets/images/zltszhfw/jlfw/jlfw.jpg"/>
                </el-row>

                <el-row class="menu-box">
                    <div>
                        <div class="menu-level1"
                             @click="changeMenu('威海市计量授权机构查询','0101','/main/zltszhfw/jlfw/whsjlsqjgcx')">
                            威海市计量授权机构查询
                        </div>
                    </div>
                    <div>
                        <div class="menu-level1"
                             @click="changeMenu('全国社会公用计量标准信息全国计量检验检测机构查询','0201','http://psp.e-cqs.cn')">
                            全国社会公用计量标准信息<br>全国计量检验检测机构查询 <span :class="menuIcon"><i class="el-icon-link"></i></span>
                        </div>
                    </div>
                    <div>
                        <div class="menu-level1"
                             @click="changeMenu('国家计量技术规范查询','0301','http://jjg.spc.org.cn/')">
                            国家计量技术规范查询 <span :class="menuIcon"><i class="el-icon-link"></i></span>
                        </div>
                    </div>
                    <div>
                        <div class="menu-level1" @click="changeMenu('威海市“互联网+计量”公共服务','0401','os_jls')">
                            威海市“互联网+计量”公共服务 <span :class="menuIcon"><i class="el-icon-link"></i></span>
                        </div>
                    </div>
                </el-row>
            </el-col>

            <el-col :span="18" class="right-box">
                <el-row class="right-box-row">
                    <!--威海市计量授权机构查询-->
                    <el-row v-show="whsjlsqjgcxOpen">
                        <!--标题-->
                        <el-row class="right-box-row-title">
                            {{title}}
                        </el-row>

                        <el-row>
                            <el-form :model="queryParams" ref="queryParams" :inline="true" label-width="90px">
                                <el-col :span="10">
                                    <el-form-item label="机构名称：" prop="mechanismName">
                                        <el-input
                                                v-model="queryParams.mechanismName"
                                                placeholder="请输入机构名称"
                                                clearable
                                                size="small"
                                                style="width: 13rem"
                                        />
                                    </el-form-item>
                                </el-col>
                                <el-col :span="10">
                                    <el-form-item label="地址：" prop="dom">
                                        <el-input
                                                v-model="queryParams.dom"
                                                placeholder="请输入地址"
                                                clearable
                                                size="small"
                                                style="width: 13rem"
                                        />
                                    </el-form-item>
                                </el-col>

                                <el-form-item>
                                    <el-button type="primary" icon="el-icon-search" size="mini" @click="getList"
                                               style="margin-right: 20px">检 索
                                    </el-button>
                                </el-form-item>
                            </el-form>
                        </el-row>

                        <!--表格-->
                        <el-table v-loading="loading" :data="list" tooltip-effect="light"
                                  :header-cell-style="{background:'#f5f5f5f5',color:'#606266'}">
                            <el-table-column label="机构名称" align="center" prop="mechanismName"
                                              width="300"/>
                            <el-table-column label="地址" align="center" prop="dom" :show-tooltip-when-overflow="true"/>
                            <el-table-column label="联系电话" align="center" prop="tel">
                                <template slot-scope="scope">
                                    <el-tag v-if="!isLoginState">登录后查看</el-tag>
                                    <span v-if="isLoginState">{{scope.row.tel}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="授权证书编号" align="center" prop="authorizationCode"
                                             :show-tooltip-when-overflow="true"/>
                            <el-table-column label="有效日期" align="center" prop="effectiveDate" width="100">
                                <template slot-scope="scope">
                                    <span>{{ parseTime(scope.row.effectiveDate, '{y}-{m}-{d}') }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="机构等级" align="center" prop="organLevel" width="80"/>
                            <el-table-column label="授权区域" align="center" prop="mechanismRegion"/>
                        </el-table>
                        <pagination
                                v-show="total>0"
                                :total="total"
                                :page.sync="queryParams.pageNum"
                                :limit.sync="queryParams.pageSize"
                                @pagination="getList"
                        />
                    </el-row>
                </el-row>
            </el-col>
        </el-row>

    </div>
</template>

<script>
    import {updatePvNum} from "@/api/itempv/pv";
    import {getSsoDesInfo,} from "@/api/zlts/jlfw/jljgxx";
    import {listJljgxx,} from "@/api/zlts/jlfw/jljgxx";

    export default {
        name: "jlfw",
        data() {
            return {
                menuIcon: 'menu-icon',
                menuIconDown: 'menu-icon-down',
                promise: false,
                form: {},
                ssoOtherOsInfo: {},
                // 遮罩层
                loading: false,
                // 总条数
                total: 0,
                list: [],
                queryParams: {
                    pageNum: 1,
                    pageSize: 10,
                    mechanismName: undefined,
                    dom: undefined,
                },
                whsjlsqjgcxOpen: true,
                title: '威海市计量授权机构查询',
                isLoginState: undefined,
            }
        },
        created() {
            this.getList();
            updatePvNum("zlts_jlfw").then(response => {
                //pv 点击计量服务
            });
        },
        methods: {
            refresh() {
                this.getList();
            },
            getList() {
				//----【】需要修改为recid
				let ssessionLoginUser = JSON.parse(localStorage.getItem('ssessionLoginUser'));
				if (ssessionLoginUser != null && ssessionLoginUser.islogin) {
					this.isLoginState = true;
				} else {
					this.isLoginState = false;
				}
                this.loading = true;
                listJljgxx(this.queryParams).then(response => {
                    this.list = response.rows;
                    this.total = response.total;
                    this.loading = false;
                });
            },
            changeMenu(name, code, url) {
                if (code === '0101') {
                    updatePvNum("zlts_jlfw_whsjlsqjg").then(response => {
                        //pv 点击威海市计量授权机构
                    });
                    this.getList();
                } else if (code === '0201') {
                    this.openPage(url)
                } else if (code === '0301') {
                    this.openPage(url)
                } else if (code === '0401') {
                    this.openSsoPage('os_jls');
                }
            },
            openPage(url) {
                let item_key = "";
                if (url == 'http://psp.e-cqs.cn') {
                    item_key = 'zlts_jlfw_qgjlbzjjyjccx';
                    //pv 点击全国社会公用计量标准信息、全国计量检验检测机构查询服务
                } else if (url == 'http://jjg.spc.org.cn/') {
                    item_key = 'zlts_jlfw_jyjcdgqtjljsgf'
                    //pv 点击检验检测系统表检验检测规程型评大纲 其他计量技术规范查询服务
                }
                updatePvNum(item_key).then(response => {

                });
                this.utils.windowOpen(url);
            },
			openNewPage(url) {
				this.utils.windowOpen(url);
			},
            openSsoPage(syscode) {
                //单点登录跳转
				let ssessionLoginUser = JSON.parse(localStorage.getItem('ssessionLoginUser'));
				if (this.utils.isLoginTimeout()) {
					this.ssoOtherOsInfo.syscode = syscode;
					this.ssoOtherOsInfo.uuid = ssessionLoginUser.ywFwjg.uuid;
					this.ssoOtherOsInfo.usertype = ssessionLoginUser.user.ftype;
					this.ssoOtherOsInfo.loginname = ssessionLoginUser.user.realName;
					this.ssoOtherOsInfo.entname = ssessionLoginUser.user.corname;
					this.ssoOtherOsInfo.entnumber = ssessionLoginUser.user.cornumber;
                    this.ssoOtherOsInfo.ywFwjgRecid = ssessionLoginUser.user.ywFwjgRecid;
					getSsoDesInfo(this.ssoOtherOsInfo).then(response => {
						this.openNewPage(response.url + "?syscode=" + syscode + "&sign=" +
							response.sign);
						return true;
					});
				} else {
					if (ssessionLoginUser != null) {
						let ywFwjgRecid = ssessionLoginUser.user.ywFwjgRecid;
						this.$confirm(
							'登录请求已过期，您可以继续留在该页面，或者重新登录?',
							'系统提示', {
								confirmButtonText: '重新登录',
								cancelButtonText: '取消',
								type: 'warning'
							}
						).then(() => {
							this.logout(ywFwjgRecid)
						})
					} else {
						localStorage.clear();
						window.location.href = this.Config.sdtyrzfwLoginUrl;
					}
				}
            }
        }
    }
</script>

<style scoped>
    .app-container {
        padding: 10px;
        background-color: #ffffff;
    }

    .navigation {
        padding: 20px 15px;
        line-height: 20px;
        height: 60px;
        background-color: #F5F5F5;
        margin-bottom: 15px;
    }

    .left-img img {
        width: 100%;
    }

    .menu-box {
        background-color: #FAFAFA;
        padding: 15px 10px;
    }

    .menu-level1 {
        padding: 10px;
        background-color: #69B1F3;
        padding-left: 20px;
        font-size: 13px;
        text-align: left;
        margin-bottom: 10px;
        margin-top: 10px;
        cursor: pointer;
        color: white;
    }

    .menu-level2 {
        padding: 5px 20px 5px 20px;
        font-size: 12px;
        font-weight: 500;
        cursor: pointer;
    }

    .menu-icon {
        float: right;

    }

    /deep/ .el-menu {
        text-align: left;
        background-color: #FAFAFA;
        border: 0;
    }

    /*
    .menu-box /deep/.el-menu-item.is-active {
        background-color: #EAEAEA;
    }
    */

    .right-box {
        padding-left: 10px;
    }

    .right-box-row {
        border: 1px solid #cccccc;
        padding: 10px 15px;
    }

    .right-box-row-tip {
        padding: 10px;
        background-color: #FBF8E5;
    }

    .right-box-row-title {
        padding: 15px 0;
        text-align: left;
        color: #409eff;
        font-size: 18px;
        font-weight: bold;
        border-bottom: 1px solid #cccccc;
        margin: 10px 0;
    }

    .xqsq {
        min-height: 5rem;
        background-color: #ffaa00;
        color: #FFFFFF;
        font-size: 1.25rem;
        line-height: 5rem;
        border-radius: 0.0625rem;
        cursor: pointer;
    }

    .search-where {
        margin: 10px 0px;
        padding: 15px;
        background-color: #ffffff;
    }

    .search-item {
        display: flex;
        /*border-bottom: 1px solid #000000;*/
    }

    .search-item-left {
        line-height: 40px;
        font-weight: bold;
    }

    .search-item-right {
        flex: 1;
        padding: 0px 10px;
    }

    .el-input {
        width: 600px;
    }

</style>
